const ARRROUTER = [{
  path: '/',
  component: () => import('@/app_public/layout/LayoutTina.vue'),
  redirect: { name: "HomePortalTina" },
  children: [
    {
      path: "",
      name: "HomePortalTina",
      meta: { title: "Trang chủ" },
      component: () => import("./pages/HomePortal.vue"),
    },
    {
      path: "/gioi-thieu",
      name: "GioiThieu",
      meta: { title: "Giới thiệu" },
      component: () => import("./pages/About.vue"),
    },
    {
      path: "/huong-dan",
      name: "HuongDan",
      meta: { title: "Hướng dẫn" },
      component: () => import("./pages/HuongDan.vue"),
    },
    {
      path: "/chinh-sach-quy-dinh",
      name: "ChinhSachQuyDinh",
      meta: { title: "Chính sách quy định" },
      component: () => import("./pages/PrivacyPolicy.vue"),
    },
    {
      path: "/lien-he",
      name: "LienHe",
      meta: { title: "Liên hệ" },
      component: () => import("./pages/Contact.vue"),
    },

    // ===== ĐỊA ĐIỂM =====
    {
      path: 'dia-diem',
      name: 'DanhSachDiaDiem',
      meta: { title: 'Danh sách địa điểm' },
      component: () => import('./pages/location/LocationList.vue'),
    },
    {
      path: 'dia-diem/:slug',
      name: 'ChiTietDiaDiem',
      meta: { title: 'Chi tiết địa điểm' },
      component: () => import('./pages/location/LocationDetail.vue'),
    },

    // ===== LỄ HỘI =====
    {
      path: 'le-hoi',
      name: 'DanhSachLeHoi',
      meta: { title: 'Danh sách lễ hội' },
      component: () => import('./pages/festival/FestivalList.vue'),
    },
    {
      path: 'le-hoi/:slug',
      name: 'ChiTietLeHoi',
      meta: { title: 'Chi tiết lễ hội' },
      component: () => import('./pages/festival/FestivalDetail.vue'),
    },
  ]
},
];

export default function (path) {
  return ARRROUTER.map((item) => {
    if (path) item.path = "/" + path + item.path;
    return item;
  });
}
